
class FloorElement {
    constructor() {

    }
}

export default FloorElement;